import { API_BASE_URL } from "./config";

export async function parseJsonResponse(response) {
  const requestId =
    response.headers.get("x-request-id") || response.headers.get("rndr-id");
  const text = await response.text();

  if (!text) {
    return { payload: {}, requestId };
  }

  try {
    return { payload: JSON.parse(text), requestId };
  } catch {
    return {
      payload: { error: "The server returned an unexpected response." },
      requestId,
    };
  }
}

export async function memberApi(path, options = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });
  const { payload, requestId } = await parseJsonResponse(response);

  if (!response.ok) {
    const baseMessage =
      payload && typeof payload === "object" && payload.message
        ? payload.message
        : payload && typeof payload === "object" && payload.error
        ? payload.error
        : "Unable to complete the request.";
    const error = new Error(
      requestId ? `${baseMessage} Request ID: ${requestId}` : baseMessage
    );
    if (payload && typeof payload === "object") {
      error.code = payload.code || payload.error || "";
      error.payload = payload;
    }
    throw error;
  }

  return payload;
}
